import type { Messages } from './en';

export const nb: Messages = {
  "language.label": "Språk",
  "auth.login": "Logg inn",
  "auth.signup": "Opprett konto",
  "auth.signupTitle": "Opprett kontoen din",
  "auth.signupLead": "Opprett kontoen din, bekreft e-posten din, så kan den gratis prøveperioden starte med en gang.",
  "auth.loginLead": "Logg inn med e-posten din eller brukernavnet vi sendte deg.",
  "auth.passwordChanged": "Passordet er endret. Logg inn med det nye passordet.",
  "auth.name": "Navnet ditt",
  "auth.email": "E-post",
  "auth.emailOrUsername": "E-post eller brukernavn",
  "auth.whatsapp": "WhatsApp-nummer",
  "auth.whatsappHint": "Så vi kan nå deg på WhatsApp.",
  "auth.password": "Passord",
  "auth.keepLoggedIn": "Hold meg innlogget på denne enheten",
  "auth.wait": "Vent litt…",
  "auth.forgot": "Glemt passordet?",
  "auth.enterName": "Skriv inn navnet ditt.",
  "auth.weakPassword": "Velg et sterkere passord: det må oppfylle alle punktene i listen under passordet.",
  "auth.deviceUnsupported": "Denne enheten støttes ikke.",
  "auth.loginAgain": "Logg inn på nytt.",
  "auth.accountDeleted": "Kontoen din er slettet.",
  "password.rules": "Krav til passordet",
  "password.length": "Minst 8 tegn",
  "password.upper": "En stor bokstav",
  "password.lower": "En liten bokstav",
  "password.number": "Et tall",
  "password.done": "(oppfylt)",
  "password.missing": "(mangler)",
  "phone.country": "Land: {name}, +{dial}",
  "phone.placeholder": "412 34 567",
  "phone.search": "Søk etter landet ditt",
  "phone.countries": "Land",
  "phone.noCountry": "Fant ikke noe land",
  "reset.title": "Tilbakestill passordet",
  "reset.sent": "Hvis {email} har en konto, har vi sendt en 6-sifret kode. Skriv den inn sammen med det nye passordet.",
  "reset.lead": "Skriv inn e-posten din, så sender vi deg en kode.",
  "reset.code": "Kode",
  "reset.newPassword": "Nytt passord",
  "reset.save": "Lagre nytt passord",
  "reset.send": "Send kode",
  "reset.back": "Tilbake til innlogging",
  "catalog.title": "Hvilke språk ser du TV på?",
  "catalog.lead": "Kanalene, filmene og seriene dine kommer på disse språkene, så appen laster raskt på mobil og TV.",
  "catalog.continue": "Fortsett",
  "catalog.languages": "Språk",
  "catalog.more": "Flere språk…",
  "catalog.international": "Også internasjonale filmer og serier",
  "catalog.internationalHint": "(uten bestemt språk, f.eks. «Netflix-filmer»: gjør listen større)",
  "catalog.note": "Dagens kamper på Hjem er fortsatt tilgjengelige på alle språk. Du kan endre dette når som helst under Konto.",
  "catalog.saving": "Lagrer…",
  "catalog.chooseOne": "Velg minst ett språk",
  "verify.title": "Bekreft e-posten din",
  "verify.lead": "Vi har sendt en 6-sifret kode til {email}. Skriv den inn nedenfor. Sjekk søppelpost hvis du ikke ser den.",
  "verify.code": "Kode",
  "verify.newCodeSent": "En ny kode er på vei.",
  "verify.checking": "Sjekker…",
  "verify.confirm": "Bekreft",
  "verify.resend": "Send en ny kode",
  "noAccess.noPlan.title": "Start den gratis prøveperioden",
  "noAccess.noPlan.body": "Be om en gratis prøveperiode og se alt på denne enheten. De fleste prøveperioder starter med en gang; tiden din starter første gang du spiller av noe.",
  "noAccess.noPlan.contact": "Hei, jeg vil gjerne abonnere på IPTViva.",
  "noAccess.pending.title": "Prøveperiode forespurt",
  "noAccess.pending.body": "Vi har mottatt forespørselen din og aktiverer den gratis prøveperioden snart. Denne skjermen åpner kanalene så snart den er aktiv.",
  "noAccess.pending.contact": "Hei, jeg har bedt om en gratis prøveperiode på IPTViva.",
  "noAccess.used.title": "Gratis prøveperiode allerede brukt",
  "noAccess.used.body": "Denne enheten, dette nummeret eller denne e-posten har allerede hatt en gratis prøveperiode. Abonner for å fortsette å se.",
  "noAccess.used.contact": "Hei, jeg har allerede brukt prøveperioden og vil gjerne abonnere på IPTViva.",
  "noAccess.trialEnded.title": "Den gratis prøveperioden er over",
  "noAccess.trialEnded.body": "Vi håper du likte den. Abonner for å fortsette å se: Standard for én skjerm, Premium for to samtidig.",
  "noAccess.trialEnded.contact": "Hei, prøveperioden min er over, og jeg vil gjerne abonnere på IPTViva.",
  "noAccess.expired.title": "Abonnementet ditt er utløpt",
  "noAccess.expired.body": "Forny abonnementet for å fortsette å se.",
  "noAccess.expired.contact": "Hei, jeg vil gjerne fornye IPTViva-abonnementet mitt.",
  "noAccess.sending": "Sender…",
  "noAccess.request": "Be om gratis prøveperiode",
  "noAccess.waiting": "Venter på aktivering…",
  "noAccess.contactWhatsapp": "Kontakt oss på WhatsApp",
  "noAccess.subscribeWhatsapp": "Abonner via WhatsApp",
  "noAccess.loggedInAs": "Logget inn som {name}",
  "common.logOut": "Logg ut",
  "common.cancel": "Avbryt",
  "common.back": "Tilbake",
  "common.tryAgain": "Prøv igjen",
  "delete.link": "Slett kontoen min",
  "delete.title": "Slette kontoen?",
  "delete.body": "Kontoen og dataene dine slettes for godt. Skriv inn passordet for å bekrefte.",
  "delete.deleting": "Sletter…",
  "delete.confirm": "Slett kontoen",
  "unverified.title": "Kan ikke sjekke tilgangen din",
  "unavailable.title": "IPTViva er ikke tilgjengelig",
  "unavailable.device": "Kunne ikke gjenkjenne denne enheten. Start appen på nytt og prøv igjen.",
  "unavailable.build": "Denne versjonen har ingen kontoserver satt opp (VITE_ACCOUNT_API).",
  "error.invalid-credentials": "Feil e-post, brukernavn eller passord.",
  "error.account-disabled": "Denne kontoen er deaktivert. Kontakt oss.",
  "error.trial-used-on-device": "Denne enheten har allerede hatt en gratis prøveperiode. Logg inn med en betalt konto eller kontakt oss for å abonnere.",
  "error.trial-bound-to-other-device": "Prøveperioden din brukes allerede på den andre enheten din. Abonner for å se på flere enheter.",
  "error.device-limit": "Denne kontoen brukes allerede på alle enhetene abonnementet tillater. Kontakt kundestøtte for å bruke den på en ny.",
  "error.unsupported-device": "Denne enheten støttes ikke.",
  "error.rate-limited": "For mange forsøk. Vent litt og prøv igjen.",
  "error.session-ended": "Økten din er avsluttet. Logg inn på nytt.",
  "error.invalid-email": "Skriv inn en gyldig e-post.",
  "error.disposable-email": "Engangs-e-post godtas ikke. Bruk din vanlige e-post.",
  "error.invalid-phone": "Skriv inn WhatsApp-nummeret ditt med landskode.",
  "error.weak-password": "Velg et sterkere passord: minst 8 tegn, med stor og liten bokstav og et tall.",
  "error.missing-name": "Skriv inn navnet ditt.",
  "error.email-taken": "Det finnes allerede en konto med denne e-posten. Logg inn.",
  "error.wrong-password": "Feil passord.",
  "error.invalid-code": "Koden er feil eller utløpt. Sjekk e-posten eller be om en ny.",
  "error.code-too-soon": "Vi sendte nettopp en kode. Vent et minutt før du ber om en ny.",
  "error.not-active": "Kontoen din har ikke et aktivt abonnement.",
  "error.email-unavailable": "Tilbakestilling på e-post er ikke tilgjengelig ennå. Skriv til oss på WhatsApp, så sender vi deg et nytt passord.",
  "error.invalid-input": "Velg minst ett språk.",
  "error.server-error": "Noe gikk galt. Prøv igjen.",
  "error.offline": "Får ikke kontakt med serveren. Sjekk internettforbindelsen.",
  "error.not-configured": "Kontoserveren er ikke satt opp i denne versjonen.",
  "common.close": "Lukk",
  "common.dismiss": "Skjul",
  "common.loading": "Laster…",
  "nav.main": "Hovedmeny",
  "nav.home": "Hjem",
  "nav.live": "Direkte-TV",
  "nav.movies": "Filmer",
  "nav.series": "Serier",
  "nav.search": "Søk",
  "nav.account": "Konto",
  "kind.live": "Direkte",
  "kind.movie": "Film",
  "kind.series": "Serie",
  "tile.sports": "Sport direkte",
  "tile.movies": "Filmer",
  "tile.series": "Serier",
  "tile.kids": "Barn",
  "tile.music": "Musikk",
  "tile.news": "Nyheter",
  "tile.uhd": "4K UHD",
  "tile.docs": "Dokumentarer",
  "tile.football": "Fotball",
  "tile.cinema": "Kino",
  "tile.cartoons": "Tegnefilm",
  "tile.concerts": "Konserter",
  "sync.connecting": "Kobler til",
  "sync.downloading": "Laster ned listen",
  "sync.live": "Laster direktekanaler",
  "sync.movie": "Laster filmer",
  "sync.series": "Laster serier",
  "sync.saving": "Lagrer",
  "sync.starting": "Starter",
  "sync.items": "{count} elementer",
  "sync.of": "{done} av {total}",
  "sync.adding": "Laster {name}",
  "sync.updating": "Oppdaterer {name}",
  "sync.importing": "Importerer {name}",
  "sync.busy": "Kanallisten oppdateres fortsatt. Vent til den er ferdig.",
  "errors.refused": "Leverandøren avviste forespørselen. Sjekk at kontoen er aktiv og ikke over tilkoblingsgrensen.",
  "errors.notFound": "Adressen finnes ikke på serveren.",
  "errors.serverProblem": "Leverandørens server meldte om et problem. Sørg for at ingen annen enhet bruker denne kontoen, vent et minutt og prøv igjen.",
  "errors.network": "Får ikke kontakt med serveren. Sjekk internettforbindelsen.",
  "errors.timeout": "Serveren brukte for lang tid. Prøv igjen senere.",
  "errors.http": "Serveren returnerte en feil.",
  "errors.bad-credentials": "Feil brukernavn eller passord.",
  "errors.account-expired": "Denne kontoen er utløpt. Kontakt oss.",
  "errors.account-disabled": "Denne kontoen er deaktivert. Kontakt oss.",
  "errors.empty-playlist": "Listen inneholder ingen kanaler eller videoer.",
  "errors.parse": "Kunne ikke lese listen.",
  "errors.invalid-input": "Opplysninger mangler eller er ugyldige.",
  "errors.storage": "Kunne ikke lagre dataene på denne enheten. Frigjør plass og prøv igjen.",
  "errors.cancelled": "Avbrutt.",
  "search.all": "Alle",
  "search.placeholder": "Kanaler, filmer, serier",
  "search.tooShort": "Skriv minst {count} tegn.",
  "search.none": "Ingen treff",
  "search.results": "{count} treff",
  "filter.language": "Språk",
  "filter.allLanguages": "Alle språk",
  "filter.country": "Land",
  "filter.allCountries": "Alle land",
  "browse.loadingChannels": "Laster kanalene dine… Hvis ingenting dukker opp, åpne Konto og trykk Last inn kanaler.",
  "browse.source": "Kilde",
  "browse.categories": "Kategorier",
  "browse.other": "Annet",
  "browse.recent": "Nylig lagt til",
  "browse.front": "Utvalgt",
  "browse.continue": "Fortsett å se",
  "browse.seeAll": "Se alle",
  "browse.previous": "Forrige",
  "browse.next": "Neste",
  "browse.episodes": "Episoder",
  "browse.watched": "Nylig sett",
  "favorites.title": "Favoritter",
  "favorites.add": "Legg {name} til i favoritter",
  "favorites.remove": "Fjern {name} fra favoritter",
  "series.continue": "Fortsett {episode} fra {time}",
  "browse.allFiltered": "Alle {filter}",
  "browse.empty.live": "Ingen direktekanaler her.",
  "browse.empty.movie": "Ingen filmer her.",
  "browse.empty.series": "Ingen serier her.",
  "browse.unfinished": "{kind} ble ikke ferdig lastet.",
  "browse.load.live": "Last inn direktekanaler",
  "browse.load.movie": "Last inn filmer",
  "browse.load.series": "Last inn serier",
  "browse.loading.live": "Laster direktekanaler…",
  "browse.loading.movie": "Laster filmer…",
  "browse.loading.series": "Laster serier…",
  "browse.meanwhile": "I mellomtiden er {count} direktekanaler klare under Direkte-TV.",
  "series.loading": "Laster episoder…",
  "series.seasons": "Sesonger",
  "account.username": "Brukernavn",
  "account.name": "Navn",
  "account.plan": "Abonnement",
  "account.freeTrial": "Gratis prøveperiode",
  "account.screens": "Skjermer samtidig",
  "account.unlimited": "Ubegrenset",
  "account.trialEndsIn": "Prøveperioden slutter om",
  "account.validUntil": "Gyldig til",
  "account.trialNotStarted": "{length} · starter når du spiller av noe",
  "account.noEnd": "Ingen sluttdato",
  "account.content": "Innhold",
  "account.lastLoad": "Siste lasting",
  "account.lastLoadDetail": "{total} ({waiting} venting på serveren, {download} nedlasting, {storing} lagring på denne enheten)",
  "account.loading.live": "kanaler lastes…",
  "account.loading.movie": "filmer lastes…",
  "account.loading.series": "serier lastes…",
  "account.count.live": "{count} kanaler",
  "account.count.movie": "{count} filmer",
  "account.count.series": "{count} serier",
  "account.updateChannels": "Oppdater kanaler",
  "account.loadChannels": "Last inn kanaler",
  "account.subscribe": "Abonner",
  "account.renew": "Forny",
  "account.subscribeMessage": "Hei, jeg vil gjerne abonnere på IPTViva.",
  "account.renewMessage": "Hei, jeg vil gjerne fornye IPTViva-abonnementet mitt.",
  "account.helpMessage": "Hei, jeg trenger hjelp med IPTViva.",
  "account.help": "Hjelp",
  "account.helpText": "Et spørsmål, en ny enhet eller en kanal som ikke virker? Kontakt oss, vi svarer hver dag.",
  "account.appLanguage": "Appens språk",
  "account.channelLanguages": "Kanalspråk",
  "account.international": "internasjonalt",
  "account.saveLanguages": "Lagre og last inn listen på nytt",
  "account.languagesSaved": "Lagret. Kanallisten din lastes inn på nytt med disse språkene.",
  "account.changeLanguages": "Endre språk",
  "time.minutes": "{count} min",
  "time.hoursMinutes": "{hours} t {minutes} min",
  "time.days": "{count} dager",
  "time.hour": "{count} time",
  "time.hours": "{count} timer",
  "home.loading": "Laster dagens kamper…",
  "home.failed": "Kunne ikke laste dagens kamper. Siden prøver igjen hvert minutt.",
  "home.welcome": "Velkommen",
  "home.noMatches": "Ingen store fotballkamper akkurat nå. De dukker opp her så snart vi finner kanaler som viser dem og går jevnt.",
  "home.liveNow": "Direkte nå",
  "home.laterToday": "Senere i dag",
  "home.otherLeagues": "Andre",
  "home.favouriteLeague": "Stjernemerk {league}: vis først",
  "home.unfavouriteLeague": "Fjern {league} fra favoritter",
  "home.browse": "Utforsk",
  "home.allChannels": "Alle kanaler",
  "home.anyTime": "Når som helst",
  "home.everyEpisode": "Alle episoder",
  "home.todaysMatches": "Dagens kamper",
  "home.slideOf": "{position} av {count}",
  "home.previousMatch": "Forrige kamp",
  "home.nextMatch": "Neste kamp",
  "home.football": "Fotball",
  "home.checking": "Sjekker kanaler…",
  "home.channelIn": "{count} kanal på {language}",
  "home.channelsIn": "{count} kanaler på {language}",
  "home.moreOther": "{count} til på andre språk",
  "home.noChannel": "Ingen kanal ennå",
  "home.atKickoff": "Kanalene dukker opp ved avspark, når de er sjekket",
  "home.channelsAtKickoff": "Kanaler ved avspark",
  "home.tomorrow": "I morgen",
  "home.days": "Dager",
  "home.comingUp": "Kommende kamper",
  "home.seeDay": "Se {day}",
  "home.channelsOnMatchDay": "Kanaler på kampdagen",
  "home.noMatchToday": "Ingen kamp i dag, neste {date}",
  "home.noMatchDay": "Ingen kamp denne dagen, neste {date}",
  "home.noMatchesDay": "Ingen kamper fra de store ligaene denne dagen.",
  "home.noSchedule": "Kampoppsettet for de neste dagene er ikke tilgjengelig ennå.",
  "home.watchNow": "Se nå",
  "home.details": "Detaljer",
  "home.today": "I dag",
  "home.inMinutes": "om {count} min",
  "home.inHours": "om {count} t",
  "home.oneChannel": "{count} kanal",
  "home.channels": "{count} kanaler",
  "home.oneLanguage": "{count} språk",
  "home.languages": "{count} språk",
  "home.checkingLong": "Vi sjekker kanalene som viser denne kampen. De som virker, dukker opp her om et minutt eller to.",
  "home.atKickoffLong": "Kanalene dukker opp her ved avspark, når vi har sjekket at de går jevnt.",
  "home.expectedOn": "Ventes på {name} · ikke sjekket ennå",
  "home.expectedOnMore": "Ventes på {name} +{count} · ikke sjekket ennå",
  "home.willBeOn": "Ikke sjekket ennå: disse kanalene kan ses når vi har sjekket at de går jevnt.",
  "home.mightBeOn": "Kanskje på {name}",
  "home.mightBeOnMore": "Kanskje på {name} +{count}",
  "home.mightHave": "Kan ha kampen: trykk på en for å prøve den.",
  "home.mightHaveShort": "Kan ha kampen",
  "home.moreToTry": "Flere kanaler å prøve",
  "home.notChecked": "Ikke sjekket",
  "home.searchMore": "Søk etter flere",
  "home.searchHint": "Ikke i listen? Søk etter kanalene {channels}.",
  "home.searchHintClubs": "Ikke i listen? Søk etter lagenes klubbkanaler eller kanalen som sender kampen.",
  "home.commentary": "Kommentarspråk",
  "home.playsSmoothly": "Går jevnt",
  "home.mayShowOther": "Kan vise en annen kamp",
  "home.guessesBefore": "Kampen går på én av de nummererte kanalene, men vi vet ikke hvilken ennå. Under kampen hjelper seerne oss å finne den.",
  "home.guessesLive": "Kampen går på én av de nummererte kanalene, men vi vet ikke hvilken ennå. Prøv en: vi spør deg om kampen går der.",
  "home.confirmedByViewers": "Bekreftet av seere",
  "player.matchQuestion": "Viser denne kanalen {match}?",
  "player.matchYes": "Ja",
  "player.matchNo": "Nei",
  "player.matchThanks": "Takk! Når nok seere er enige, ser alle svaret.",
  "home.notConfirmed": "Ikke bekreftet: kan være en ungdomskamp",
  "home.watchedNow": "Ses nå · starter med en gang",
  "clock.live": "DIREKTE",
  "clock.ht": "PAUSE",
  "clock.break": "Pause",
  "clock.penalties": "Straffer",
  "clock.ft": "SLUTT",
  "clock.paused": "Avbrutt",
  "player.buffering": "Laster…",
  "player.reconnecting": "Kobler til på nytt…",
  "player.paused": "Satt på pause",
  "player.pausedByOtherApp": "Satt på pause av en annen app (en samtale?). Trykk på Spill av for å se direkte.",
  "player.soundOffByOtherApp": "Lyden er av mens en annen app (en samtale?) bruker den. Trykk for å slå den på.",
  "player.soundOffShort": "Lyd av (en samtale?) · trykk for å slå på",
  "player.finished": "Ferdig",
  "player.connecting": "Kobler til…",
  "player.queueTitle": "Den gratis prøveperioden starter om",
  "player.queueNext": "Du er neste.",
  "player.queuePosition": "Du er nummer {position} i køen.",
  "player.queueBody": "Alle prøveplassene er opptatt akkurat nå. Avspillingen starter av seg selv, så la denne skjermen være åpen. Prøvetiden din starter når du får en plass.",
  "player.anyMoment": "Når som helst nå…",
  "player.uhdTitle": "4K og 8K støttes ikke på denne enheten",
  "player.uhdBody": "Denne enheten kan ikke spille av 4K eller 8K, så tittelen er ikke tilgjengelig her, og katalogen har ingen HD-versjon av den. Bytt til en annen enhet, for eksempel en nyere TV, datamaskin eller telefon, for å få hele katalogen.",
  "browse.uhdHidden": "4K- og 8K-titler er skjult: denne enheten kan ikke spille dem av. Bytt til en annen enhet for å få hele katalogen.",
  "browse.uhdPaused": "4K- og 8K-titler er satt på pause inntil videre: du ser HD-versjonene. TV-appene for LG og Samsung har fortsatt hele katalogen.",
  "player.uhdPausedTitle": "4K og 8K er satt på pause inntil videre",
  "player.uhdPausedBody": "4K- og 8K-titler er ikke tilgjengelige her inntil videre, og denne har ingen HD-versjon. Prøv igjen senere, eller bruk TV-appen vår for LG eller Samsung for hele katalogen.",
  "player.uhdPausedSwitched": "4K er satt på pause inntil videre: HD-versjonen spilles.",
  "player.uhdSwitched": "Denne enheten kan ikke spille av 4K: HD-versjonen spilles i stedet.",
  "player.renewBody": "Forny for å fortsette å se.",
  "player.trialEndedBody": "Vi håper du likte den. Abonner for å fortsette å se.",
  "player.fullOne": "Ses allerede på {count} skjerm",
  "player.full": "Ses allerede på {count} skjermer",
  "player.fullBodyOne": "Abonnementet ditt tillater én skjerm om gangen. Stopp den for å se her.",
  "player.fullBody": "Abonnementet ditt tillater {count} skjermer samtidig. Stopp én for å se her.",
  "player.stopAndWatch": "Stopp {device} og se her",
  "player.replacedTitle": "Stoppet fra en annen skjerm",
  "player.replacedBody": "Abonnementet ditt tillater et begrenset antall skjermer samtidig, og denne ble stoppet så en annen enhet kunne se. Premium tillater to skjermer samtidig.",
  "player.watchHere": "Se her",
  "player.muted": "Lyd av",
  "player.volumePercent": "Volum {percent} %",
  "player.behindLive": "{time} bak direkte. Gå til direkte",
  "player.goLive": "Gå til direkte",
  "player.prev": "Forr.",
  "player.next": "Neste",
  "player.previous": "Forrige",
  "player.previousChannel": "Forrige kanal",
  "player.nextChannel": "Neste kanal",
  "player.previousEpisode": "Forrige episode",
  "player.nextEpisode": "Neste episode",
  "player.back10": "10 sekunder tilbake",
  "player.forward10": "10 sekunder frem",
  "player.play": "Spill av",
  "player.pause": "Pause",
  "player.audio": "Lyd",
  "player.subtitles": "Undertekster",
  "player.info": "Info",
  "player.fullscreen": "Fullskjerm",
  "player.off": "Av",
  "player.quality": "Kvalitet",
  "player.qualityStandard": "Standard",
  "player.qualityUnplayable": "{quality} kan ikke spilles av på denne enheten; tilbake til forrige kvalitet.",
  "player.seek": "Posisjon",
  "player.mute": "Slå av lyd",
  "player.unmute": "Slå på lyd",
  "player.volume": "Volum",
  "player.upNext": "Neste: {name}",
  "player.playNext": "Neste episode",
  "player.watchAgain": "Se igjen",
  "playback.network": "Fikk ikke kontakt med strømmen. Sjekk forbindelsen eller prøv igjen senere.",
  "playback.stalled": "Strømmen sluttet å sende video.",
  "playback.no-start": "Strømmen startet ikke. Serveren kan være nede eller veldig treg.",
  "playback.forbidden": "Leverandøren avviste denne strømmen. Kontoen kan ha nådd tilkoblingsgrensen.",
  "playback.not-found": "Denne kanalen er ikke lenger tilgjengelig hos leverandøren.",
  "playback.unsupported": "Formatet på denne strømmen støttes ikke på denne enheten.",
  "playback.media": "Kunne ikke dekode videoen.",
  "stats.title": "Avspillingsstatistikk",
  "stats.engine": "Motor",
  "stats.resolution": "Oppløsning",
  "stats.buffered": "Buffer",
  "stats.stalls": "Stopp",
  "stats.dropped": "Tapte bilder",
  "stats.reconnects": "Nye tilkoblinger",
  "stats.sound": "Lyd",
  "stats.converted": "konvertert til AAC",
  "stats.convertedFrom": "konvertert til AAC fra {codec}",
  "stats.original": "original",
  "stats.started": "Startet på",
  "stats.problems": "Siste problemer",
  "stats.none": "ingen",
};
